module.exports = __webpack_public_path__ + "img/artist-04.bc6e5b2d.png";